import { TokenManager } from "@/core/auth/token-manager";
import { OperatorAppsResponse } from '../types/operator-types';
import { ApiErrorMiddleware } from '@/core/api-error-middleware';

export class OperatorApi {
  constructor(
    private readonly baseUrl: string,
    private readonly tokenManager: TokenManager
  ) { }

  async getOperatorApps(distributorId?: string): Promise<OperatorAppsResponse> {
    const headers = await this.tokenManager.getAuthHeaders();
    
    // Build URL with optional distributor query parameter
    let url = `${this.baseUrl}/actor/apps`;
    if (distributorId) {
      url += `?distributorId=${encodeURIComponent(distributorId)}`;
    }

    const response = await ApiErrorMiddleware.fetchWithErrorHandling(
      url,
      {
        method: 'GET',
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
      },
      'Operator API',
      '/actor/apps'
    );

    return await response.json();
  }
}